module.exports = __webpack_public_path__ + "img/fg6.a9d0bfa0.jpg";